import { useClientsStore } from '@/store/clients';
import { useUsersStore } from '@/store/users';
import { useContactsStore } from '@/store/contacts';
import { useOpportunitiesStore } from '@/store/opportunities';

export const activitiesOptions = {
  searchClientsAndLeads: async (query: string | Record<string, any> = '') => {
    const store = useClientsStore();
    await store.searchClientsAndLeads(query);
    return store.clients_leads;
  },
  searchUsers: async (query: string | Record<string, any> = '') => {
    const store = useUsersStore();
    await store.searchUsers(query);
    return store.users_result;
  },
  searchContacts: async (query: string | Record<string, any> = '') => {
    const store = useContactsStore();
    await store.searchContact(query);
    return store.contacts_result;
  },
  searchOpportunity: async (params = {}) => {
    const store = useOpportunitiesStore();
    await store.fetchOpportunities(params);
    return store.opportunities;
  }
};
